import React, { Component } from 'react';
import PropTypes from "prop-types";
import { EuiComment } from '../../../../src/components/comment_list';
import { EuiButtonIcon } from '../../../../src/components/button';
import { EuiText } from '../../../../src/components/text';
import { EuiPopover } from '../../../../src/components/popover';
import { EuiContextMenuPanel, EuiContextMenuItem } from '../../../../src/components/context_menu';
var body = /*#__PURE__*/React.createElement(EuiText, {
  size: "s"
}, /*#__PURE__*/React.createElement("p", null, "This comment has custom actions available. See the upper right corner."));

class _default extends Component {
  state = {
    isPopoverOpen: false
  };
  togglePopover = () => {
    this.setState(prevState => ({
      isPopoverOpen: !prevState.isPopoverOpen
    }));
  };
  closePopover = () => {
    this.setState({
      isPopoverOpen: false
    });
  };

  render() {
    const {
      isPopoverOpen
    } = this.state;
    const customActions = <EuiPopover button={<EuiButtonIcon aria-label="Actions" iconType="gear" size="s" color="text" onClick={() => this.togglePopover()} />} isOpen={isPopoverOpen} closePopover={() => this.closePopover()} panelPaddingSize="none" anchorPosition="leftCenter">
        <EuiContextMenuPanel items={[<EuiContextMenuItem key="A" icon="pencil" onClick={() => {
        this.closePopover();
      }}>
              Edit
            </EuiContextMenuItem>, <EuiContextMenuItem key="B" icon="share" onClick={() => {
        this.closePopover();
      }}>
              Share
            </EuiContextMenuItem>, <EuiContextMenuItem key="C" icon="copy" onClick={() => {
        this.closePopover();
      }}>
              Copy
            </EuiContextMenuItem>]} />
      </EuiPopover>;
    return <div>
        <EuiComment username="janed" event="added a comment" actions={customActions} timestamp="Jan 1, 2020">
          {body}
        </EuiComment>
      </div>;
  }

}

_default.propTypes = {
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string
};
export { _default as default };

try {
  commentactions.__docgenInfo = {
    description: '',
    displayName: 'commentactions',
    methods: [],
    props: {
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'HTMLAttributes'
        },
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: 'Defines a string value that labels the current element.\n@see aria-labelledby.',
        name: 'aria-label',
        parent: {
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'AriaAttributes'
        },
        required: false,
        type: {
          name: 'string'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        required: false,
        type: {
          name: 'string'
        }
      }
    },
    extendedInterfaces: ['HTMLAttributes', 'AriaAttributes', 'DOMAttributes', 'CommonProps']
  };
} catch (e) {}